import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ChevronLeft } from 'components/icons';
import styles from 'styles/components/checkout/caap/backButton.scss';

const BackButton = ({ href }, { testId = f => f }) => (
  <div className={`${styles.backButtonContainer} ${styles.showOnlySmallScreen}`}>
    <Link to={href} data-test-id={testId('backButton')}>
      <h4>
        <ChevronLeft color="black" size={24}/> Back
      </h4>
    </Link>
  </div>
);

BackButton.contextTypes = {
  testId: PropTypes.func
};

export default BackButton;
